export const intervalsData = [
  {
    id: 0,
    interval: 'None'
  },
  {
    id: 1,
    interval: 'Hourly'
  },
  {
    id: 2,
    interval: 'Daily'
  },
  {
    id: 3,
    interval: 'Weekly'
  },
  {
    id: 4,
    interval: 'Monthly'
  },
  {
    id: 5,
    interval: 'Yearly'
  },
  {
    id: 6,
    interval: 'Quarterly'
  },
  {
    id: 7,
    interval: 'Bi-annually'
  }
];
